// extracted by mini-css-extract-plugin
export default {"card":"yY-z","carouselContainer":"zY-z","carouselContent":"AY-z"};